module.exports = __webpack_public_path__ + "50889613399e629085bc6f3b71a36527.png";